import React, { useRef } from 'react'

import { IconContext } from "react-icons"
import { IoRocket } from 'react-icons/io5'
import { FaCode } from 'react-icons/fa'
import { RiLineChartFill } from 'react-icons/ri'
import { FaPhoneAlt } from 'react-icons/fa'
import { GrMail } from 'react-icons/gr'
import { IoLogoWhatsapp } from 'react-icons/io5'
import { FaFacebookSquare } from 'react-icons/fa'

import { MdChangeHistory } from 'react-icons/md'
import mathfuse_logo from "../assets/mathfuse_logo.png"
import jjuth_logo from "../assets/jjuth.jpg"
import homeprops_logo from "../assets/homeprops_logo.png"


function Home({ servicesRef, portfolioRef, contactRef }) {

     // for page scrolling on button click
     const findOutMoreBtnRef = useRef(null)

     const handleFindOutMoreBtn = () => {
        // scroll to about section, offset by navbar height for better positioning
        window.scrollTo(0, findOutMoreBtnRef.current.offsetTop - 30)
    }

    return (
        <React.Fragment>
            <div style={{ paddingBottom: "0px", margin: "0px"}}>

                {/* landing image */}
                <div className="custom-landing-image"></div>

                {/* landing text and button */}
                <h1
                    style={{    position: "absolute", 
                                top: "30%", 
                                left: 0,
                                width: "100%",
                                textAlign: "center", 
                                color: "#ffffff",
                                fontFamily: "Merriweather Sans",
                                fontWeight: 700,
                                fontSize: 64,
                            }}
                > 
                    DEVIYENT
                </h1>

                <h3 
                    style={{    position: "absolute", 
                                top: "44%", 
                                left: 0,
                                width: "100%",
                                textAlign: "center",
                                color: "#ffffff",
                                fontFamily: "Roboto",
                                fontWeight: "normal",
                                fontSize: 30,
                            }}
                >
                    Prosperity through Technology
                </h3>

                
                <button className="button is-medium is-rounded is-white is-outlined"
                        style={{    position: "absolute", 
                                    top: "63%", 
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    buttonColor: "#ff7e29",
                                    fontFamily: "Nunito",
                                    fontWeight: "bold"                                
                                }}
                        onClick={handleFindOutMoreBtn}
                >
                    FIND OUT MORE
                </button>
            </div>

            {/* about */}
            <section className="hero" style={{ backgroundColor: "whitesmoke"}} ref={findOutMoreBtnRef}>
                <div className="hero-body" ref={servicesRef}>
                    <p  className="title has-text-centered">
                    </p>

                    <p className="subtitle has-text-centered">
                        Deviyent is aimed at empowering individuals, entrepreneurs and businesses with the 
                        help of cutting edge technology. 
                    </p>
                </div>
            </section>

            {/* services */}
            <section className="hero">
                <br />
                <div className="hero-body">
                    <p className="title has-text-centered" style={{ fontSize: "27px" }}>
                        SERVICES
                    </p>
                    <hr 
                        style={{ backgroundColor: "#f05f40", width: "100px", height: "4px", margin: "auto"}}
                    />
                    <br /><br />
                    <div className="subtitle has-text-centered">
                        <div className="columns">
                            <div className="column">
                                <div className="section container box">
                                    <IconContext.Provider value={{ color: "#f05f40", size: "48px" }}>
                                        <IoRocket />
                                    </IconContext.Provider>
                                    <br /><br />
                                    <p className="title is-4">
                                        Social Media Marketing
                                    </p>
                                    <p className="subtitle is-6">
                                        Use the power of Social Media to grow your business.
                                    </p>
                                </div>
                            </div>
                            <div className="column">
                                <div className="section container box">
                                    <IconContext.Provider value={{ color: "#f05f40", size: "48px" }}>
                                        <FaCode />
                                    </IconContext.Provider>
                                    <br /><br />
                                    <p className="title is-4">
                                        Web Development
                                    </p>
                                    <p className="subtitle is-6">
                                        Beautiful, responsive and secure websites at an affordable price.
                                    </p>
                                </div>
                            </div>
                            <div className="column">
                                <div className="section container box">
                                    <IconContext.Provider value={{ color: "#f05f40", size: "48px" }}>
                                        <RiLineChartFill />
                                    </IconContext.Provider>
                                    <br /><br />
                                    <p className="title is-4">
                                        SEO and Analytics
                                    </p>
                                    <p className="subtitle is-6">
                                        Reach more people and Gain valuable insights.
                                    </p>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
                <br /><br />
            </section>

            {/* portfolio */}
            <section className="hero" style={{ backgroundColor: "whitesmoke" }}>
                <div className="hero-body"  ref={portfolioRef}>
                    <div className="title is-6 has-text-centered">
                        <div className="columns">
                            <div className="column" style={{ paddingBottom: "24px" }}>
                                <IconContext.Provider value={{ color: "#f05f40", size: "64px" }}>
                                    <MdChangeHistory />
                                </IconContext.Provider>
                                <br /><br />
                                DEVIYENT.COM
                            </div>
                            <div className="column" style={{ paddingBottom: "42px" }}>
                                <a href="https://www.mathfuse.com" target="_blank" rel="noreferrer">
                                    <figure className="image is-64x64 is-inline-block">
                                        <img src={mathfuse_logo} alt="mathfuse logo"/>
                                    </figure>
                                    <br /><br />
                                </a>
                                MATHFUSE.COM
                            </div>
                            <div className="column" style={{ paddingBottom: "42px" }}>
                                <a href="https://www.jjuteachershealth.in" target="_blank" rel="noreferrer">
                                    <figure className="image is-64x64 is-inline-block">
                                        <img src={jjuth_logo} alt="jjuth logo"/>
                                    </figure>
                                    <br /><br />
                                </a>
                                JJUTEACHERSHEALTH.IN
                            </div>
                            <div className="column" style={{ paddingBottom: "42px" }}>
                                <a href="https://www.homeprops.in" target="_blank" rel="noreferrer">
                                    <figure className="image is-64x64 is-inline-block">
                                        <img src={homeprops_logo} alt="homeprops logo"/>
                                    </figure>
                                    <br /><br />
                                </a>
                                HOMEPROPS.IN
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* contact */}
            <section className="hero">
                <br />
                <div className="hero-body" ref={contactRef}>
                    <p className="title has-text-centered" style={{ fontSize: "27px" }}>
                        CONTACT US
                    </p>
                    <hr 
                        style={{ backgroundColor: "#f05f40", width: "100px", height: "4px", margin: "auto"}}
                    />
                    <br /><br />
                    <div className="subtitle has-text-centered">
                        <p className="subtitle is-5">
                            Give us a call or send us an email and we will get back to you as soon as possible!
                        </p>
                        <div className="columns section">
                            <div className="column" style={{ paddingBottom: "36px" }}>
                                <div className="container">
                                    <IconContext.Provider value={{ color: "#f05f40", size: "42px" }}>
                                        <FaPhoneAlt />
                                    </IconContext.Provider>
                                    <br /><br />
                                    <p className="title is-5">
                                        +91 84730 29411
                                    </p>
                                </div>
                            </div>
                            <div className="column" style={{ paddingBottom: "36px" }}>
                                <div className="container">
                                    <IconContext.Provider value={{ color: "#f05f40", size: "42px" }}>
                                        <GrMail />
                                    </IconContext.Provider>
                                    <br /><br />
                                    <p className="title is-5">
                                        deviyent@gmail.com
                                    </p>
                                </div>
                            </div>
                            <div className="column" style={{ paddingBottom: "36px" }}>
                                <div className="container">
                                    <a href="https://wa.me/918723010898" target="_blank" rel="noreferrer">
                                        <IconContext.Provider value={{ color: "#f05f40", size: "42px" }}>
                                            <IoLogoWhatsapp />
                                        </IconContext.Provider>
                                        <br /><br />
                                        <p className="title is-5">
                                            Chat on WhatsApp!
                                        </p>
                                    </a>
                                </div>
                            </div>
                            <div className="column" style={{ paddingBottom: "36px" }}>
                                <div className="container">
                                    <a href="https://www.facebook.com/deviyent" target="_blank" rel="noreferrer">
                                        <IconContext.Provider value={{ color: "#f05f40", size: "42px" }}>
                                            <FaFacebookSquare />
                                        </IconContext.Provider>
                                        <br /><br />
                                        <p className="title is-5">
                                            facebook.com/deviyent
                                        </p>
                                    </a>
                                </div>
                            </div>
                        </div> 
                    </div>
                </div>
            </section>
    </React.Fragment>
    )
}

export default Home
